import { routing } from '@/i18n/routing';
import { defaultLocale, LocaleCode } from '@/i18n/locales';

export const getLocaleFromPathname = (pathname: string): LocaleCode => {
  const match = pathname.match(/^\/([a-z]{2})(?:\/|$)/);
  const candidate = match?.[1];
  if (candidate && routing.locales.includes(candidate as LocaleCode)) {
    return candidate as LocaleCode;
  }
  return defaultLocale;
};

export const buildLocalizedPath = (locale: LocaleCode, pathname: string): string => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (locale === defaultLocale) {
    return normalizedPath;
  }
  if (normalizedPath === '/') {
    return `/${locale}`;
  }
  return `/${locale}${normalizedPath}`;
};
